import { render } from "./photos-uploader.vue?vue&type=template&id=19ff0a69"
import script from "./photos-uploader.vue?vue&type=script&lang=js"
export * from "./photos-uploader.vue?vue&type=script&lang=js"

import "./photos-uploader.vue?vue&type=style&index=0&id=19ff0a69&lang=scss&rel=stylesheet%2Fscss"
script.render = render

export default script